import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  Box,
  Chip,
  Button,
  DialogActions,
} from "@mui/material";
import { useTranslation } from "../../../../hooks/useTranslation";

export const OutOfCriteriaReasonsDialog = ({
  reasons,
}: {
  reasons: string[];
}) => {
  const { translate, translateWithoutPrefix } = useTranslation(
    "pages.inventoryManagement.inventory.list.fields",
  );
  const [open, setOpen] = useState(false);

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="start"
      flexDirection="column"
      justifyContent="center"
    >
      <Typography width="100%" noWrap>
        {reasons[0]}
      </Typography>
      {reasons.length > 1 && (
        <Chip
          color="primary"
          size="small"
          onClick={() => setOpen(true)}
          label={translate("outOfCriteriaMoreButton", {
            count: reasons.length - 1,
          })}
          sx={{
            "& .MuiChip-label": {
              lineHeight: "1",
            },
          }}
        />
      )}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{translate("outOfCriteriaReasons")}</DialogTitle>
        <Divider />
        <DialogContent>
          <List
            sx={{
              maxHeight: 300,
              overflowY: "auto",
              padding: 0,
            }}
          >
            {reasons.map((reason) => (
              <ListItem
                key={reason}
                sx={{
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  padding: "8px 16px",
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="body1" color="text.primary">
                      {reason}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {translateWithoutPrefix("buttons.close")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
